import React, { useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Navbar, Nav, NavDropdown, Container, Button } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./header.css";
import "./footer.css";
import { Link } from "react-router-dom";

const Header = () => {


  const [showEmailModal, setShowEmailModal] = useState(false);


  const handleEmailClick = () => setShowEmailModal(true);
  const handleCloseEmail = () => setShowEmailModal(false);

  const [expanded, setExpanded] = useState(false);

const toggleNavbar = (isOpen) => {
  setExpanded(isOpen);
};

const closeNavbar = () => {
  setExpanded(false);
};

return (
    <>
    
      {/* Top Header Section */}
      <div className="container-fluid bg-primary px-5 d-none d-lg-block">
        <div className="row gx-0 align-items-center">
          <div className="col-lg-5 text-center text-lg-stAAT mb-lg-0">
            <div className="d-flex">
              {/* Email Link with Popup */}
              <a href="#" className="text-muted me-4" onClick={handleEmailClick}>
                <i className="fas fa-envelope text-secondary me-2"></i>
                enquiries@Bajwaimmigration.com
              </a>
              {/* Phone Link with Popup */}
              <a href="/contact" className="text-muted me-4">
                <i className="fas fa-phone text-secondary me-2"></i>Contact Us
              </a>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="col-lg-3 text-center mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center" style={{ height: "45px" }}>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="https://api.whatsapp.com/send/?phone=61406401000&text&type=phone_number&app_absent=0">
                <i className="fab fa-whatsapp fw-normal text-secondary"></i>
              </a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="https://www.facebook.com/bajwaimmigration">
                <i className="fab fa-facebook-f fw-normal text-secondary"></i>
              </a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="https://www.tiktok.com/@bajwaimmigration">
                <i className="fab fa-tiktok fw-normal text-secondary"></i>
              </a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href="https://www.instagram.com/bajwaimmigration/">
                <i className="fab fa-instagram fw-normal text-secondary"></i>
              </a>
              <a className="btn btn-sm btn-outline-light btn-square rounded-circle" href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw">
                <i className="fab fa-youtube fw-normal text-secondary"></i>
              </a>
            </div>
          </div>



          {/* Scrolling Text */}
          <div className="col-lg-4 text-center text-lg-end">
            <div className="d-inline-flex align-items-center scrolling-text-container">
              <p className="scrolling-text">
              WE HAVE OFFICES LOCATED ACROSS THE WORLD
              </p>
            </div>
          </div>
        </div>
      </div>

      {/*  Call Confirmation Modal */}
      {/* {showCallModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Call</h5>
                <button type="button" className="btn-close" onClick={handleCloseCall}></button>
              </div>
              <div className="modal-body">
                <p>Do you want to call <strong>+0406 401 000</strong>?</p>
              </div>
              <div className="modal-footer">
                <a href="tel:+0406401000" className="btn btn-primary">Call</a>
                <button type="button" className="btn btn-secondary" onClick={handleCloseCall}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {/*  Email Confirmation Modal */}
      {showEmailModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Email</h5>
                <button type="button" className="btn-close" onClick={handleCloseEmail}></button>
              </div>
              <div className="modal-body">
                <p>Do you want to send an email to <strong>enquiries@Bajwaimmigration.com</strong>?</p>
              </div>
              <div className="modal-footer">
                <a href="mailto:enquiries@Bajwaimmigration.com" className="btn btn-primary">Send Email</a>
                <button type="button" className="btn btn-secondary" onClick={handleCloseEmail}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/*  Background Overlay for Modals */}
      {/* {(showEmailModal) && <div className="modal-backdrop fade show"></div>} */}

{/* NavBar */}

<Navbar bg="light" expand="lg" expanded={expanded} onToggle={toggleNavbar}>
<Container fluid className="nav-container">
    <div className="brand-toggle-container">
      <Navbar.Brand href="/" className="brand-container">
        <img
          src="./img/brand-logo.png"
          alt="Brand Logo"
          className="brand-logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        className="hamburger-menu"
      />
    </div>
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="mx-auto">
        <Nav.Link href="/" onClick={closeNavbar}>Home</Nav.Link>
        <Nav.Link as={Link} to="/about" onClick={closeNavbar}>About</Nav.Link>

{/* working visa */}
        <NavDropdown title="Skilled Visas" id="Skilled-visas-dropdown">
          <NavDropdown.Item as={Link} to="/skilledID" onClick={closeNavbar}>
            Skilled Independent Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/nominatedvisa" onClick={closeNavbar}>
            Skilled Nominated Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/workregionalvisa" onClick={closeNavbar}>
          Skilled Work Regional Visa
          </NavDropdown.Item>
          {/* <NavDropdown.Item as={Link} to="/skilledregional" onClick={closeNavbar}>
          Skilled Regional Visa
          </NavDropdown.Item> */}
        </NavDropdown>

{/* immigration visa */}

<NavDropdown title=" Immigration Services
" id="immigration-services-dropdown">
          <NavDropdown.Item as={Link} to="/ausvisa" onClick={closeNavbar}>
          Australian Visa Services
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/AATappeal" onClick={closeNavbar}>
          Visa Appeals (ART / AAT) 
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/citizenship" onClick={closeNavbar}>
          Citizenship
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/partner" onClick={closeNavbar}>
          Partner Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/skill" onClick={closeNavbar}>
          Skill Assessment
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/visitorvisa" onClick={closeNavbar}>
          Visitor Visa
          </NavDropdown.Item>
        </NavDropdown>

{/* student services */}

<NavDropdown title="Student Services" id="student-services-dropdown">
          <NavDropdown.Item as={Link} to="/coursechange" onClick={closeNavbar}>
          Admission and Course Change
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/professional" onClick={closeNavbar}>
          Professional Year
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/temporarygraduate" onClick={closeNavbar}>
          Temporary Graduate Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/workingvisa" onClick={closeNavbar}>
          Working and Skilled Visa
          </NavDropdown.Item>
        </NavDropdown>

{/* migration */}

<NavDropdown title="Migration" id="migration-dropdown">
          <NavDropdown.Item as={Link} to="/canadavisa" onClick={closeNavbar}>
          Canada Student Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/ukvisa" onClick={closeNavbar}>
          UK Student Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/usavisa" onClick={closeNavbar}>
          USA Student Visa
          </NavDropdown.Item>
          <NavDropdown.Item as={Link} to="/nzvisa" onClick={closeNavbar}>
          New Zealand Student Visa
          </NavDropdown.Item>
        </NavDropdown>

        <Nav.Link as={Link} to="/blog" onClick={closeNavbar}>Blog</Nav.Link>
        <Nav.Link as={Link} to="/contact" onClick={closeNavbar}>Contact Us</Nav.Link>
      </Nav>
      <Button
  variant="primary"
  href="https://au.bajwaimmigration.com/book-appointment"
  className="book-btn"
>
  Book Appointment
</Button>
    </Navbar.Collapse>
  </Container>
</Navbar>


    </>
);
};

export default Header;